import { ReactNode } from "react";

import { DialogContent, DialogContentProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { layout } from "theme/tokens/semantic/layout";

interface IBasicDialogContent extends DialogContentProps {
  children: ReactNode;
  noOverflow?: boolean; //use this when you need scrollable tabs in the content
}

const useStyles = makeStyles({
  root: (props: Omit<IBasicDialogContent, "children">) => ({
    "&&&": {
      paddingTop: `${layout.dialog.bodyPaddingY}px`,
      paddingBottom: `${layout.dialog.bodyPaddingY}px`,
      paddingLeft: `${layout.dialog.paddingX}px`,
      paddingRight: `${layout.dialog.paddingX}px`,
    },
    ...(props.noOverflow && {
      display: "flex",
      flexDirection: "column",
      overflowY: "hidden",
      height: "100%",
    }),
  }),
});

const BasicDialogContent = ({
  children,
  noOverflow,
  ...props
}: IBasicDialogContent) => {
  const classes = useStyles({ noOverflow });
  return (
    <DialogContent classes={classes} {...props}>
      {children}
    </DialogContent>
  );
};

export default BasicDialogContent;
